<template>
  <div class="vd-gl-content">
    <a-row class="vd-toolbar">
      <a-col class="vd-toolbar-left vd-bar">
        <a-form layout="inline">
          <a-form-item>
            <a-input
              class="vd-input-xs"
              type="text"
              v-model="searchForm.nickname"
              placeholder="姓名"
            />
          </a-form-item>
          <a-form-item>
            <a-input
              class="vd-input-xs"
              type="text"
              v-model="searchForm.username"
              placeholder="工号"
            />
          </a-form-item>
          <a-form-item>
            <a-button icon="search" type="primary" @click="search" />
          </a-form-item>
          <a-form-item>
            <a-button @click="exportData"> 导出数据</a-button>
          </a-form-item>
        </a-form>
      </a-col>
    </a-row>

    <a-table row-key="id" :pagination="pagination" :data-source="list">
      <a-table-column align="center" title="ID" data-index="id" />
      <a-table-column title="手机号" data-index="mobile" />
      <a-table-column title="推广人" data-index="nickname" />
      <a-table-column title="工号" data-index="username" />
      <a-table-column title="收集时间" data-index="add_time">
        <template slot-scope="item">
          {{ $FormatUtil.timestamp2date(item) }}
        </template>
      </a-table-column>
    </a-table>
  </div>
</template>

<script>
import { auto_collect_list, auto_export_data } from '@/api/auto'
import { get_area_tree } from '@/api/auth'
export default {
  name: 'Member',
  data() {
    return {
      activeId: undefined,
      searchForm: {
        username: undefined,
        nickname: undefined,
      },
      list: [],
      pagination: {
        total: 1,
        current: 1,
        pageSize: 10,
        hideOnSinglePage: true,
        onChange: (page) => {
          this.pagination.current = page
          this.getData()
        },
      },
    }
  },
  mounted() {
    this.activeId = parseInt(this.$route.query.id)
    this.name = this.$route.query.name
    // 获取管理地区信息
    get_area_tree().then((res) => {
      if (res.code === 1) {
        this.areaTree = res.areaTree
      }
    })
    if (!this.$HelperUtil.isEmpty(this.activeId)) {
      this.getData()
    }
  },
  methods: {
    getData() {
      auto_collect_list({
        activeId: this.activeId,
        current: this.pagination.current,
        pageSize: this.pagination.pageSize,
        username: this.searchForm.username,
        nickname: this.searchForm.nickname,
      }).then((res) => {
        if (res.code === 1) {
          this.list = res.list
          this.pagination.total = res.total
        } else {
          this.$message.warning({ content: res.msg, key: 'data' })
        }
      })
    },
    search() {
      this.pagination.current = 1
      this.pagination.total = 0
      this.getData()
    },
    exportData() {
      auto_export_data({
        activeId: this.activeId,
        username: this.searchForm.username,
        nickname: this.searchForm.nickname,
      }).then((res) => {
        if (res.type === 'application/json') {
          let reader = new FileReader()
          reader.readAsText(res, 'utf-8')
          reader.addEventListener('loadend', () => {
            let msg = JSON.parse(reader.result)
            this.$message.error(msg.msg)
          })
        } else {
          const disposition = res.headers['content-disposition']
          let fileName = disposition.substring(
            disposition.indexOf('filename=') + 9,
            disposition.length
          )
          let link = document.createElement('a')
          link.style.display = 'none'
          let url = window.URL.createObjectURL(
            new Blob([res.data], {
              type: 'application/vnd.ms-excel',
            })
          )
          link.href = url
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          window.URL.revokeObjectURL(url)
        }
      })
    },
  },
}
</script>

<style scoped></style>
